import { ReactNode } from 'react';
import { Box } from '@mantine/core';
import { useDaily } from '@daily-co/daily-react';
import { ParticipantTile } from './ParticipantTile';

interface VideoGridProps {
  participantIds: string[];
  controls?: ReactNode;
}

export const VideoGrid = ({ participantIds, controls }: VideoGridProps) => {
  const daily = useDaily();

  // Calculate grid columns based on number of participants
  const getGridCols = (count: number): number => {
    if (count <= 1) return 1;
    if (count <= 2) return 2;
    if (count <= 4) return 2;
    return 3; // 5-6 participants
  };

  const gridCols = getGridCols(participantIds.length);
  const localSessionId = daily?.participants()?.local?.session_id;

  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${gridCols}, 1fr)`,
        gap: '16px',
        width: '100%',
        height: '100%',
        padding: '16px',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {participantIds.map((sessionId) => (
        <ParticipantTile
          key={sessionId}
          sessionId={sessionId}
          controls={sessionId === localSessionId ? controls : undefined}
        />
      ))}
    </Box>
  );
};
